import React, { Component } from 'react';
import classNames from 'classnames';
import ContainerDimensions from 'react-container-dimensions';
import Waypoint from 'react-waypoint';

import './index.css';

export default class LazyImage extends Component {
    constructor(props) {
        super(props);

        const { width, height } = getDimensionsFromSrc(props.src);

        this.state = {
            src: "",
            loaded: false,
            remove: false,
            origWidth: width,
            origHeight: height,
            aspectRatio: height / width
        };

        this.loadImage = this.loadImage.bind(this);
    }

    loadImage() {
        this.ref.onload = () => {
            this.setState({
                loaded: true,
                src: this.props.src
            })
        }

        this.ref.onerror = () => {
            this.setState({
                remove: true
            })
        }

        this.ref.src = this.props.src;
    }

    render() {
        const {
            alt = "",
            className,
            placeholderColor
        } = this.props;

        const {
            src,
            loaded,
            remove,
            aspectRatio
        } = this.state;

        if (remove) {
            return null;
        }

        const isPortrait = aspectRatio > 1;

        return (
            <div className='lazy-image-container'>
                <ContainerDimensions>
                    {({ width }) => (
                        <Waypoint onEnter={this.loadImage}>
                            <div className='lazy-image-inner-container'>
                                <img
                                    src={src}
                                    alt={alt}
                                    className={classNames('image', className)}
                                    ref={ref => this.ref = ref}
                                    width={isPortrait ? .6 * width : width}
                                    height={isPortrait ? aspectRatio * .6 * width : aspectRatio * width}
                                ></img>
                                <div
                                    style={{
                                        height: isPortrait ? aspectRatio * .6 * width : aspectRatio * width,
                                        width: isPortrait ? .6 * width : width,
                                        backgroundColor: placeholderColor
                                    }}
                                    className={classNames('lazy-image-placeholder', {
                                        loaded,
                                        portrait: isPortrait
                                    })}
                                >
                                </div>
                            </div>
                        </Waypoint>
                    )}
                </ContainerDimensions>
            </div>
        );
    }
}

function getDimensionsFromSrc(src) {
    const re = src.match(/([0-9]+)x([0-9]+)/);

    if (re) {
        return {
            width: re[1],
            height: re[2]
        };
    }

    return {
        width: 1280,
        height: 960
    };
}



// WEBPACK FOOTER //
// ./src/components/LazyImage/index.js